module.exports = "/_next/static/images/0b32fef4db1dd10cc73df3bff2772a5f-hero-large.jpg";